import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_robosinvestidores.png",
      alt: "Opere com os Robôs Investidores",
    },
    title: "Opere com os Robôs Investidores",

    // String ou array de strings
    text: [
      "Desde 2017 desenvolvendo estratégias 100% automatizadas, mais de 500 alunos treinados para operar com robôs. Devido a muitos pedidos resolvi liberar algumas de nossas estratégias mais robustas e confiáveis. Agora chegou a sua hora de usar nossas estratégias.",
    ],
    testimonial: {
      text: "Transparência e longevidade no mercado financeiro é o nosso foco",
      author: {
        name: "Marcelo Carvalho, CEO Robôs Investidores.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias BotFamily.",
    heading: "Estratégias robustas e lucrativas à sua disposição.",
    subtitle:
      "Estratégias criadas por quem entende do assunto pensadas no menor risco possível.",
  },

  cta: {
    title: "Vem conosco!",
    subtitle: "Ative agora mesmo nossas estratégias.",
    buttonText: "Ativar extensão!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Robôs Investidores.",
    col1: [
      "Criado em 2017 com intuito de mostrar a realidade de quem opera com robôs traders. Estou sempre mostrando com total transparência dias de lucros e dias de perdas, afinal nem sempre se ganha no mercado financeiro.",
      "No ano de 2020, devido a inúmeros pedidos para saber como criava minhas estratégias, resolvi montar a primeira mentoria do Brasil relacionada a robôs traders, chamada BotFamily. Ensinei mais de 500 alunos a operar no mercado financeiro com robôs/ estratégias consistentes. Atualmente tenho meu próprio algoritmo de criação e validação de estratégias.",
    ],
    col2: [
      "Em meados de 2022, resolvi abrir algumas de minhas estratégias para terceiros e hoje algumas de nossas estratégias do Botfamily estão disponíveis para o público em geral.",
      // "Elimine a tensão de operar manualmente e tenha ganhos extraordinários. Participe deste grupo de investidores ganhadores!",
    ],
  },

  stats: {
    title: "Alguns de nossos números",
    subtitle: "Mais de 6 anos criando e ensinando as pessoas a usarem robôs.",
    data: [
      {
        value: "+6",
        description: "Anos usando e criando robôs.",
      },
      {
        value: "+500",
        description: "Alunos formados.",
      },
      {
        value: "+1000",
        description: "Estratégias criadas ao longo dos anos.",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Porque utilizar os robôs da BotFamily?",
    // subtitle: "Veja quais as principais vantagens dos robôs da TraderBot.",
    data: [
      {
        icon: iconsSet.money_off,
        title: "7 Dias para testar",
        description:
          "Confira nossas estratégias e tenha certeza que usará algo robusto.",
      },
      {
        icon: iconsSet.settings,
        title: "100% Automatizado",
        description:
          "Todos os testes são feitos de forma automática em algoritmo próprio.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Individual",
        description:
          "Estamos sempre atendendo pedidos e auxiliando em eventuais dúvidas.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Algoritmo pronto para analisar milhares de variáveis em poucos segundos.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Aproveite seu dia enquanto nossas estratégias operam por você, não perca tempo na frente da tela.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description: "Elimine o fator emocional das suas operações.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Iniciei no mundo dos robôs de investimentos através da mentoria do Botfamily, mudei completamente minha visão de mercado. Passei a utilizar e criar meus próprios robôs tendo assim resultados muito fora da curva. Parabéns Marcelo e equipe.",
      author: "Jonathas Monteiro",
      job: "Consultor Financeiro",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Meu contato com bots e estratégias automatizadas de trading veio com a mentoria BotFamily. Mudei minha percepção sobre a forma de realizar os trades, como usar os indicadores e, principalmente, a visão estatística da coisa toda. Nem preciso dizer que recomendo.",
      author: "Michel Bastos",
      job: "Biólogo",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
